import React from "react";

export const PageHeader = ({ title, subtitle, actions }) => (
  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-6">
    <div>
      <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight font-display text-foreground">{title}</h1>
      {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);

export const EmptyState = ({ icon: Icon, title, description, action }) => (
  <div className="flex flex-col items-center justify-center text-center py-16 px-4 rounded-xl border border-dashed bg-card">
    {Icon && (
      <div className="h-14 w-14 rounded-2xl bg-accent flex items-center justify-center mb-4">
        <Icon className="h-7 w-7 text-primary" />
      </div>
    )}
    <h3 className="text-lg font-semibold font-display">{title}</h3>
    {description && <p className="text-sm text-muted-foreground mt-1 max-w-sm">{description}</p>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);
